import { Element3, Profile2User, User, ClipboardText, Book1, Calculator } from '@/components/icons';
import {
    AssetsPage,
    DashboardPage,
    PatientsPage,
    ProfilePage,
    SurveysPage,
    ToolsPageRoute,
} from '@/pages/constants';
import { createPageUrl } from '@/utils';
import { SidebarItem } from './types';

export const navigationItems: Array<SidebarItem> = [
    {
        title: 'Painel',
        url: createPageUrl(DashboardPage),
        icon: Element3,
        tourId: 'tour-sidebar-dashboard',
    },
    {
        title: 'Pacientes',
        url: createPageUrl(PatientsPage),
        icon: Profile2User,
        tourId: 'tour-sidebar-patients',
    },
    {
        title: 'Formulários',
        url: createPageUrl(SurveysPage),
        icon: ClipboardText,
        tourId: 'tour-sidebar-surveys',
    },
    {
        title: 'Instrumentos',
        url: createPageUrl(AssetsPage),
        icon: Book1,
        tourId: 'tour-sidebar-assets',
    },
    {
        title: 'Calculadoras',
        url: createPageUrl(ToolsPageRoute),
        icon: Calculator,
        tourId: 'tour-sidebar-tools',
    },
    {
        title: 'Perfil',
        url: createPageUrl(ProfilePage),
        icon: User,
        tourId: 'tour-sidebar-profile',
    },
];
